import ProfilePage from "@/features/profile/pages/profile";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(profile)/profile/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="w-full">
      <ProfilePage />
    </div>
  );
}
